import { FC } from 'react';
import { IntlProvider } from 'react-intl';

import { useLocale } from '@app/hooks';
import { englishLocaleKey } from '@app/constants';

interface LocalizationProviderProps {
  messages?: Record<string, string>;
  locale?: string;
}

export const LocalizationProvider: FC<LocalizationProviderProps> = ({
  children,
  messages,
  locale,
}) => {
  const { locale: translationLocale, translationMessages } = useLocale(
    !messages
  );

  return (
    <IntlProvider
      locale={locale || translationLocale || englishLocaleKey}
      messages={messages || translationMessages}
    >
      {children}
    </IntlProvider>
  );
};
